import React from 'react'
import PropTypes from 'prop-types'

const ActorCard = (props) => {
    const { actor, isSelected, clickHandler } = props
    const {
        ID, name, avatar, stats, status,
    } = actor
    const damage = status.damage || 0

    const className = `actor__card ${isSelected ? 'selected' : ''}`

    return (
        <div className={className} onClick={() => clickHandler(ID)}>
            <div className="actor__card--img" role="img" aria-label="avatar">
                {avatar}
            </div>
            <div className="actor__card--name">
                {` ${name}`}
            </div>
            <progress
                className="actor__card--bar health__bar"
                value={stats.hp - damage}
                max={stats.hp}
            />
        </div>
    )
}

ActorCard.propTypes = {
    actor: PropTypes.object.isRequired,
    clickHandler: PropTypes.func.isRequired,
    isSelected: PropTypes.bool.isRequired,
}

export default ActorCard
